import React, { useContext } from "react";

import { observer } from "mobx-react";

import classNames from "classnames";
import { EventContext } from "@gp/components";
import { EventOffer } from "@gp/offer";

import {
	EventPageSubheader,
	EventFullInfo,
} from "@features/offer/desktop/event";

import { additionalOfferClose } from "@utils/offer";

export const AdditionalOfferEvent = observer(function AdditionalOfferEvent() {
	const event = useContext(EventContext) as EventOffer;

	const onClose = () => additionalOfferClose();

	return (
		// EVENT PAGE TODO: are those styles necessary?
		<div
			className={classNames("event", {
				"event--live": event.isLive,
				"event--upcoming": event.isUpcoming,
			})}
		>
			<EventPageSubheader onClose={onClose} />
			<EventFullInfo />
		</div>
	);
});
